/* eslint-disable no-useless-escape */
/* eslint-disable prefer-destructuring */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
const nipValidator = nip => {
  if (nip.length !== 10 || !/^\d+$/.test(nip)) return false;

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const digits = Array.from(nip);
  let checkSum = 0;

  for (const idx in weights) {
    checkSum += weights[idx] * digits[idx];
  }

  checkSum %= 11;

  if (checkSum === 10) checkSum = 0;
  if (checkSum !== parseInt(digits[9])) return false;

  return true;
};

const regonValidator = regon => {
  if ((regon.length !== 9 && regon.length !== 14) || !/^\d+$/.test(regon))
    return false;

  const digits = Array.from(regon);
  const weightsForShort = [8, 9, 2, 3, 4, 5, 6, 7];
  const weightsForLong = [2, 4, 8, 5, 0, 9, 7, 3, 6, 1, 2, 4, 8];
  let checkSum = 0;
  let controlNumber;

  if (digits.length === 9) {
    for (const idx in weightsForShort) {
      checkSum += weightsForShort[idx] * digits[idx];
    }
    controlNumber = digits[8];
  } else {
    for (const idx in weightsForLong) {
      checkSum += weightsForLong[idx] * digits[idx];
    }
    controlNumber = digits[13];
  }

  checkSum %= 11;
  if (checkSum === 10) checkSum = 0;

  if (checkSum !== parseInt(controlNumber)) return false;

  return true;
};

export const validatePayload = payload => {
  const errors = [];
  // validate buffer
  if (parseInt(payload.buffer) < 0 || parseInt(payload.buffer) > 100001)
    errors.push('buffer');

  // validate phone
  const phoneRegex = /(\+|00)?[1-9][0-9 \-\(\)\.]{7,32}$/;
  if (!payload.phone.match(phoneRegex)) errors.push('phone');

  // validate email
  const mailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!payload.email.match(mailRegex)) errors.push('email');

  // validate nip
  if (!nipValidator(payload.nip)) errors.push('nip');

  // validate regon
  if (!regonValidator(payload.regon)) errors.push('regon');
  return errors;
};

export const validateCheck = (name, value) => {
  const arrName = [
    'name',
    'username',
    'firstName',
    'lastName',
    'city',
    'topic',
    'description',
  ];
  const arrOthers = ['street', 'number'];
  if (name === 'phone' && testPhone(value)) return true;
  if (name === 'email' && testEmail(value)) return true;
  if (name === 'nip' && testDigits(value, 10, 10)) return true;
  if (name === 'regon' && testDigits(value, 9, 14)) return true;
  if (name === 'buffer' && testDigits(value, 0, 100000)) return true;
  if (arrName.includes(name) && testText(value)) return true;
  if (arrOthers.includes(name) && testOther(value)) return true;
  return false;
};

const testText = field => {
  const reg = /^[a-zA-Z\s]+$/;
  return reg.test(field) && field.length >= 3;
};

const testOther = field => {
  const reg = /^[a-zA-Z0-9\s\.-]+$/;
  return reg.test(field);
};

const testEmail = field => {
  // eslint-disable-next-line no-control-regex
  const reg = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
  return reg.test(field);
};

function testPhone(field) {
  const reg = /^[\+]?[0-9]{2}[0-9]{9}|^[0-9]{9}$|^[0-9]{3}$/gm;
  // eslint-disable-next-line no-param-reassign
  field = field.replace(/ /g, '');
  const lng = field.length;
  return reg.test(field) && lng >= 3 && lng <= 12;
}

function testDigits(field, min, max) {
  const reg = /^\d+$/;
  const lng = field.length;
  return reg.test(field) && lng >= min && lng <= max;
}
